<template>
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    @click="$emit('click')"
  >
    <path
      d="m17.917 20h-7.5c-0.55232-7e-4
    -1.0818-0.2204-1.4724-0.6109-0.39056-0.3906-0.61026-0.9201-0.61093-1.4724v-7.5c0-0.56087
    0.42375-0.86045 0.79709-1.125 0.44708-0.31584 0.86954-0.61417 0.86954-1.375
    0-0.11051 0.0439-0.21649 0.1221-0.29463 0.0781-0.07814 0.1841-0.12204
    0.2946-0.12204h7.5c0.1105 0 0.2165 0.0439 0.2946 0.12204 0.0782 0.07814
    0.1221 0.18412 0.1221 0.29463 0 0.76083 0.4225 1.0592 0.8696 1.375 0.375
    0.26416 0.797 0.56375 0.797 1.125v7.5c-6e-4 0.5523-0.2203 1.0818-0.6109
    1.4724-0.3905 0.3905-0.9201 0.6102-1.4724 0.6109zm-7.1158-11.667c-0.0694
    0.34248-0.2114 0.66607-0.4167 0.94887-0.2052 0.2828-0.4688 0.51821-0.77291
    0.6903-0.27583 0.1942-0.44458 0.3192-0.44458 0.4442v7.5c0 0.3315 0.13169
    0.6494 0.36611 0.8838 0.23442 0.2345 0.55238 0.3662 0.88388
    0.3662h7.5c0.3315 0 0.6495-0.1317 0.8839-0.3662 0.2344-0.2344 0.3661-0.5523
    0.3661-0.8838v-7.5c0-0.125-0.1687-0.25-0.4446-0.4442-0.3041-0.17209-0.5677-0.4075-0.7729-0.6903s-0.3473-0.60639-0.4167-0.94887h-6.7316z"
    />
    <path
      d="m18.333 6.6668h-8.3333c-0.33152
    0-0.64946-0.1317-0.88388-0.36612s-0.36612-0.55236-0.36612-0.88388v-0.83333c0-0.33152
    0.1317-0.64947 0.36612-0.88389s0.55236-0.36611 0.88388-0.36611h8.3333c0.3316
    0 0.6495 0.13169 0.8839 0.36611s0.3661 0.55237 0.3661 0.88389v0.83333c0
    0.33152-0.1317 0.64946-0.3661 0.88388s-0.5523 0.36612-0.8839
    0.36612zm-8.3333-2.5c-0.11051 0-0.21649 0.0439-0.29463 0.12204s-0.12204
    0.18412-0.12204 0.29463v0.83333c0 0.11051 0.0439 0.21649 0.12204
    0.29463s0.18412 0.12204 0.29463 0.12204h8.3333c0.1105 0 0.2165-0.0439
    0.2947-0.12204 0.0781-0.07814 0.122-0.18412
    0.122-0.29463v-0.83333c0-0.11051-0.0439-0.21649-0.122-0.29463-0.0782-0.07814-0.1842-0.12204-0.2947-0.12204h-8.3333z"
    />
    <path d="M10.8333 6.25H10V7.91667H10.8333V6.25Z" />
    <path d="M18.3333 6.25H17.5V7.91667H18.3333V6.25Z" />
    <path d="M16.6667 17.5H8.75V18.3333H16.6667V17.5Z" />
    <path
      d="m16.667
    10.834h-7.9167v0.8333h7.9167v-0.8333z"
    />
    <path
      d="M11.25
    5H10.4166V6.25H11.25V5Z"
    />
    <path
      d="M12.9167
    5H12.0834V6.25H12.9167V5Z"
    />
    <path
      d="M14.5833
    5H13.75V6.25H14.5833V5Z"
    />
    <path
      d="M16.25
    5H15.4166V6.25H16.25V5Z"
    />
    <path
      d="M17.9167
    5H17.0834V6.25H17.9167V5Z"
    />
    <path
      d="m15 17.084h-1.6667c-0.1105
    0-0.2165-0.0439-0.2946-0.122-0.0782-0.0782-0.1221-0.1842-0.1221-0.2947v-0.8333h-0.8333c-0.1105
    0-0.2165-0.0439-0.2946-0.122-0.0782-0.0782-0.1221-0.1842-0.1221-0.2947v-1.6666c0-0.1105
    0.0439-0.2165 0.1221-0.2947 0.0781-0.0781 0.1841-0.122
    0.2946-0.122h0.8333v-0.8333c0-0.1105 0.0439-0.2165 0.1221-0.2947
    0.0781-0.0781 0.1841-0.122 0.2946-0.122h1.6667c0.1105 0 0.2164 0.0439 0.2946
    0.122 0.0781 0.0782 0.122 0.1842 0.122 0.2947v0.8333h0.8334c0.1105 0 0.2164
    0.0439 0.2946 0.122 0.0781 0.0782 0.122 0.1842 0.122 0.2947v1.6666c0
    0.1105-0.0439 0.2165-0.122 0.2947-0.0782 0.0781-0.1841 0.122-0.2946
    0.122h-0.8334v0.8333c0 0.1105-0.0439 0.2165-0.122 0.2947-0.0782
    0.0781-0.1841 0.122-0.2946 0.122zm-1.25-0.8333h0.8333v-0.8334c0-0.1105
    0.0439-0.2165 0.122-0.2946 0.0782-0.0781 0.1842-0.122
    0.2947-0.122h0.8333v-0.8334h-0.8333c-0.1105
    0-0.2165-0.0439-0.2947-0.122-0.0781-0.0781-0.122-0.1841-0.122-0.2946v-0.8334h-0.8333v0.8334c0
    0.1105-0.0439 0.2165-0.1221 0.2946-0.0781 0.0781-0.1841 0.122-0.2946
    0.122h-0.8333v0.8334h0.8333c0.1105 0 0.2165 0.0439 0.2946 0.122 0.0782
    0.0781 0.1221 0.1841 0.1221 0.2946v0.8334z"
    />
    <path
      d="M18.3333
    17.5H17.5V18.3333H18.3333V17.5Z"
    />
    <path
      d="m18.333
    10.834h-0.8333v0.8333h0.8333v-0.8333z"
    />
    <path
      d="M7.5
    20H0.416667C0.30616 20 0.200179 19.9561 0.122039 19.878C0.0438987 19.7998 0
    19.6938 0 19.5833V3.75C2.35989e-05 3.6395 0.0439378 3.53354 0.122083
    3.45542L3.45542 0.122083C3.53354 0.0439378 3.6395 2.35989e-05 3.75
    0H14.5833C14.6938 0 14.7998 0.0438987 14.878 0.122039C14.9561 0.200179 15
    0.30616 15 0.416667V2.5H14.1667V0.833333H3.9225L0.833333
    3.9225V19.1667H7.5V20Z"
    />
    <path
      d="m3.75
    4.1665h-3.3333v-0.83333h2.9167v-2.9167h0.83334v3.3333c0 0.1105-0.0439
    0.21648-0.12204 0.29462s-0.18412 0.12204-0.29463 0.12204z"
    />
    <path d="m7.5 5.8335h-4.5833v0.83333h4.5833v-0.83333z" />
    <path
      d="m7.5
    7.5h-5.4167v0.83333h5.4167v-0.83333z"
    />
    <path
      d="m7.5
    9.1665h-5.4167v0.83334h5.4167v-0.83334z"
    />
    <path
      d="m7.5
    10.834h-5.4167v0.8333h5.4167v-0.8333z"
    />
    <path
      d="m7.5
    12.5h-5.4167v0.8333h5.4167v-0.8333z"
    />
    <path
      d="m5.8334
    14.166h-3.75v0.8333h3.75v-0.8333z"
    />
    <path
      d="m7.5
    14.166h-0.83333v0.8333h0.83333v-0.8333z"
    />
    <title v-if="title !== ''">{{ title }}</title>
  </svg>
</template>

<script>
export default {
  name: "PrescricaoMedicamentoMin",
  props: {
    title: {
      type: String,
      default: "",
    },
  },
};
</script>
